import { CS_API_URL, ACC_KEY } from "../config";

export const saveEnrollment = async (enrollmentId, restFields, sign) => {
  // const myHeaders = new Headers()
  // myHeaders.append('Authorization', `Bearer ${ACC_KEY}`)

  const formdata = new FormData();
  if (enrollmentId) formdata.append("enrollment_id", enrollmentId);
  if (sign) formdata.append("sign", sign);
  for (let i in restFields) {
    formdata.append(i, restFields[i]);
  }
  formdata.append(
    "channel",
    new URLSearchParams(window.location.search).has("agent_id")
      ? "Agent"
      : "Web"
  );
  const requestOptions = {
    method: "POST",
    // headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };

  const url = `${CS_API_URL}enrollment/save`;

  const response = await fetch(url, requestOptions);
  return response.json();
};

export const getEnrollmentRecord = async (enrollmentId, sign) => {
  // const myHeaders = new Headers()
  // myHeaders.append('Authorization', `Bearer ${ACC_KEY}`)

  const formdata = new FormData();
  formdata.append("enrollment_id", enrollmentId);
  if (sign) formdata.append("sign", sign);

  const requestOptions = {
    method: "POST",
    // headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };

  const url = `${CS_API_URL}enrollment/retrieve`;

  const response = await fetch(url, requestOptions);
  return response.json();
};

export const confirmEnrollment = async (
  enrollmentId,
  specialPro,
  sign,
  utmContent,
  username,
  password,
  customerId,
  testSplitDeposit
) => {
  // const myHeaders = new Headers()
  // myHeaders.append('Authorization', `Bearer ${ACC_KEY}`)

  const formdata = new FormData();
  formdata.append("enrollment_id", enrollmentId);
  if (sign) formdata.append("sign", sign);
  if (utmContent) formdata.append("utm_content", utmContent);
  for (const key in specialPro) {
    if (specialPro[key]) formdata.append(key, specialPro[key]);
  }
  if (customerId) formdata.append("customer_id", customerId);
  if (username) formdata.append("username", username);
  if (password) formdata.append("password", password);
  if (testSplitDeposit) formdata.append("test", testSplitDeposit);

  const requestOptions = {
    method: "POST",
    // headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };

  const url = `${CS_API_URL}enrollment/submit`;

  const response = await fetch(url, requestOptions);
  return response.json();
};

const cacheStoreForInput = new Map();

export const getEnrollmentInputs = async (providerId, zipcode, utilityCode) => {
  // Helper to generate a consistent cache key, handling undefined/null
  const createCacheKey = (pid, zc, uc) =>
    String(
      `getEnrollmentInputs_${pid || "none"}_${zc || "none"}_${uc || "none"}`
    );

  const cacheKey = createCacheKey(providerId, zipcode, utilityCode);

  if (cacheStoreForInput.has(cacheKey)) {
    return cacheStoreForInput.get(cacheKey);
  }

  const fetchPromise = (async () => {
    try {
      const formdata = new FormData();
      // Append parameters only if they have a value, though the cache key handles undefined/null
      if (providerId) formdata.append("provider_id", providerId);
      if (zipcode) formdata.append("zipcode", zipcode);
      if (utilityCode) formdata.append("utility_code", utilityCode);

      const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      const url = `${CS_API_URL}enrollment/input`;
      const response = await fetch(url, requestOptions);

      if (!response.ok) {
        const errorText = await response.text();
        console.error(
          `Enrollment inputs fetch failed [${cacheKey}]: ${response.status}`,
          errorText
        );
        cacheStoreForInput.delete(cacheKey);
        return new Error(`API error ${response.status} for enrollment inputs`);
      }

      const data = await response.json();
      console.log(`Enrollment inputs API success [${cacheKey}]`);
      return data;
    } catch (err) {
      console.error(`Enrollment inputs fetch error [${cacheKey}]:`, err);
      cacheStoreForInput.delete(cacheKey);
      throw err;
    }
  })();

  cacheStoreForInput.set(cacheKey, fetchPromise);
  return fetchPromise;
};

export const saveEnrollmentPaymentInfo = async (
  enrollmentId,
  paymentResponse,
  sign,
  confirmationNumber,
  paidAmount,
  onlyDeposit
) => {
  // const myHeaders = new Headers()
  // myHeaders.append('Authorization', `Bearer ${ACC_KEY}`)

  const agentParamIsTrue =
    new URLSearchParams(window.location.search).get("isAgent") === "true";

  const formdata = new FormData();
  formdata.append("enrollment_id", enrollmentId);
  formdata.append("response", paymentResponse);
  formdata.append("sign", sign);
  formdata.append("paid_amount", paidAmount);
  formdata.append("agent", agentParamIsTrue);
  formdata.append("autopay_setup", onlyDeposit);
  if (confirmationNumber) {
    formdata.append("confirmation_number", confirmationNumber);
  }

  const requestOptions = {
    method: "POST",
    // headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };

  const url = `${CS_API_URL}enrollment/icg`;

  const response = await fetch(url, requestOptions);
  return response.json();
};

export const fetchServiceSwitchOptions = async (state) => {
  const createCacheKey = (state) =>
    String(`fetchServiceSwitchOptions_${state || "none"}`);

  const cacheKey = createCacheKey(state);

  if (cacheStoreForInput.has(cacheKey)) {
    return cacheStoreForInput.get(cacheKey);
  }

  const fetchPromise = (async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);

      const url = `${CS_API_URL}utility/switch_type`;
      const formdata = new FormData();
      // Only append if value exists to avoid undefined strings
      if (state) formdata.append("state_id", state);

      const response = await fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: formdata,
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error(
          `Service switch options fetch failed [${cacheKey}]: ${response.status}`,
          errorText
        );
        cacheStoreForInput.delete(cacheKey);
        return new Error(
          `API error ${response.status} for service switch options`
        );
      }

      const data = await response.json();
      console.log(`Service switch options API success [${cacheKey}]`);
      return data;
    } catch (err) {
      console.error(`Service switch options fetch error [${cacheKey}]:`, err);
      cacheStoreForInput.delete(cacheKey);
      throw err;
    }
  })();

  cacheStoreForInput.set(cacheKey, fetchPromise);
  return fetchPromise;
};

export const fetchBlackoutDate = async (
  utilityCode,
  available_from_date,
  available_until_date
) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);

  const formdata = new FormData();
  formdata.append("utility_code", utilityCode);
  formdata.append("available_from_date", available_from_date);
  formdata.append("available_until_date", available_until_date);

  const url = `${CS_API_URL}enrollment/blackout_date`;

  const response = await fetch(url, {
    method: "POST",
    headers: myHeaders,
    body: formdata,
  });

  return response.json();
};
